<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.query.whCode" filterable placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in WhCodeList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" >
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.matName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item">
                        <el-select v-model="mainSearch.query.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCodeList">
                            <el-option v-for="(item, index) in storageObj.lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectTableData">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetClick('mainSearch')">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="批次号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.batchNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.orderCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.query.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.query.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="拆包">
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M10_B1'" @click="showUnpackingDialog">拆包</el-button>
                <!-- <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M10_B2'" @click="showMergePackageDialog">合包</el-button> -->
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M10_B3'" @click="showUnpackingAndPackagingDialog">记录</el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M10_B4'" @click="rePrintBarcode()">标签打印</el-button>
            </plabel>
            <h-table :summary-method="getSummaries" show-summary :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getTableData" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="selectRepertory">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="通道编号" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="批次号" prop="batchNo" align="center">
                </el-table-column>
                <el-table-column label="库位" prop="lcCode" align="center">
                </el-table-column>     
                <el-table-column label="包装箱号" prop="boxBarcode" align="center">
                </el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <el-table-column label="物料状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
                    </template>
                </el-table-column>
                <el-table-column label="入库时间" prop="matCreateTime" align="center" :formatter="dateFormat" width="140px">
                </el-table-column>
            </h-table>
        </box>
        <el-dialog class="unpacking-dialog" title="拆包" :visible.sync="unpackDialog" width="32%" @close="NoUnpacking">
            <div style="font-size: 16px">
                <el-row type="flex" justify="space-between" style="margin: 10px;height:50px">
                    <span style="height:50px;line-height:50px">原包装编号</span>
                    <el-col :span="14" style="height:50px;line-height:50px">
                        <el-input v-model="unpack.boxBarcode" @keyup.enter.native="submit"></el-input>
                    </el-col>
                    <div style="height:50px;line-height:50px;">
                        <el-button class="btn-t-edit" @click="submit">
                            查询
                        </el-button>
                    </div>
                </el-row>
                <!-- <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>新包装编码</span>
                    <el-col :span="14">
                        <el-input :disabled="true" placeholder="确认后自动生成"> </el-input>
                    </el-col>
                </el-row> -->
                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>通道编号</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.whCode
          }}</span>
                </el-row>
                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>工厂编号</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.fcCode
          }}</span>
                </el-row>
                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>物料编号</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.matCode
          }}</span>
                </el-row>
                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>物料描述</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.matName
          }}</span>
                </el-row>
                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>批次号</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.batchNo
          }}</span>
                </el-row>
                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>物料状态</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.wiStatus=='NORMAL'?'正常':unpackDate.wiStatus=='FREEZE'?'拣配中':unpackDate.wiStatus=='DELETE'?'作废':unpackDate.wiStatus=='OVERTIME'?'过期':unpackDate.wiStatus=='AGFREEZE'?'人工冻结':''
          }}</span>
                </el-row>

                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>库位编号</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.lcCode
          }}</span>
                </el-row>

                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>入库时间</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.matCreateTime
          }}</span>
                </el-row>
                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>规值</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.matSpecs
          }}</span>
                </el-row>
                <!-- <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>更新时间</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.updateTime
          }}</span>
                </el-row> -->
                <el-row type="flex" justify="space-between" style="margin: 10px">
                    <span>数量</span>
                    <span style="color: #1f6cec">{{
            unpackDate && unpackDate.matQuan
          }}</span>
                </el-row>
                <br />
                <el-divider></el-divider>
                <br />
                <el-row type="flex" justify="space-between" align="middle">
                    <!-- <span style="width:100px">新包装位置</span> -->
                    <!-- <el-col :span="20">
                        <el-cascader :key="keyValue" v-model="lcCodeType" :options="inventoryLocationList" :props="optionProps" collapse-tags clearable style="width:280px">
                        </el-cascader>
                    </el-col> -->
                    <span style="width:100px">新包装货位</span>
                    <el-col :span="24">
                        <!-- <el-form-item label="移入货位"> -->
                        <el-select v-model="lcCodeByLcType" placeholder="请选择" @change="getLcCodeIsCorrect()" filterable remote :remote-method="remoteMethodLcCode">
                            <el-option v-for="(item, index) in lcCodeByLcTypeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>
                        <!-- </el-form-item> -->
                    </el-col>
                </el-row>
                <el-row type="flex" justify="space-between" align="middle" style="margin:10px 10px">
                    <span>每箱数量</span>
                    <el-col :span="20">
                        <el-input-number v-model="boxNumber" :min="0" label="描述文字"></el-input-number>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="space-between" align="middle" style="margin:10px 10px">
                    <span>拆分箱数</span>
                    <el-col :span="20">
                        <el-input-number v-model="boxCount" :min="1" label="描述文字"></el-input-number>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="NoUnpacking" class="btn-t-info">取 消</el-button>
                <el-button :loading="unpackings" class="btn-t-edit" @click="unpacking">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 拆合包记录 -->
        <!-- :close="closeProductPullDialog" -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.91,0.9)" title="拆合包记录" :visible.sync="unpackingAndPackagingDialog">
            <div style="font-size: 16px">
                <el-form label-position="right" label-width="80px" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="记录类型" class="EL-Form-Item">
                            <el-select v-model="recordType" filterable @change="changeRecordType">
                                <el-option value="unpacking" label="拆包"></el-option>
                                <el-option value="mergePackage" label="合包"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-input v-model="unpackingAndPackagingSearch.matCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="物料描述" class="EL-Form-Item">
                            <el-input v-model="unpackingAndPackagingSearch.matName" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="批次号" class="EL-Form-Item">
                            <el-input v-model="unpackingAndPackagingSearch.batchNo" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button class="btn-t-edit" @click="changeRecordType">
                                查询
                            </el-button>
                            <el-button class="btn-t-delete" @click="resetUnpackingAndPackaging">重置</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="库位编号" class="EL-Form-Item">
                            <el-input v-model="unpackingAndPackagingSearch.laCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="箱号" class="EL-Form-Item">
                            <el-input v-model="unpackingAndPackagingSearch.boxBarcode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="开始日期" class="EL-Form-Item">
                            <el-date-picker v-model="unpackingAndPackagingSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions2"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="结束日期" class="EL-Form-Item">
                            <el-date-picker v-model="unpackingAndPackagingSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions1"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <el-button :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFileExport">导出EXCEL</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
                <h-table v-if="recordType == 'unpacking'" :headerCellStyle="unpackingAndPackagingData.headerCellStyle" :style="$popups.harvestRecordStyle(0.65)" @pageChange="getUnpackingData" :data="unpackingAndPackagingData.data" pagination :nowPage.sync="unpackingAndPackagingData.nowPage" :pageSize.sync="unpackingAndPackagingData.pageSize" :total.sync="unpackingAndPackagingData.total" @selectionChange="selectAllDel">
                    <!-- <el-table-column type="selection" align="center"> </el-table-column> -->
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <el-table-column label="原数量" prop="boxQuan" align="center">
                    </el-table-column>
                    <el-table-column label="新数量" prop="newBoxQuan" align="center">
                    </el-table-column>
                    <el-table-column label="批次号" prop="batchNo" align="center">
                    </el-table-column>
                    <el-table-column label="库位编号" prop="laCode" align="center">
                    </el-table-column>
                    <el-table-column label="原箱号" prop="boxBarcode" align="center" width="210px">
                    </el-table-column>
                    <el-table-column label="新箱号" prop="newBoxBarcode" align="center" width="210px">
                    </el-table-column>
                    <el-table-column label="拆包时间" prop="createTime" align="center" width="170px">
                    </el-table-column>
                    <el-table-column label="规值" prop="matSpecs" align="center">
                    </el-table-column>
                    <el-table-column label="操作人" prop="person" align="center">
                    </el-table-column>
                    <el-table-column label="操作人工号" prop="personNumber" align="center">
                    </el-table-column>
                </h-table>
                <h-table v-if="recordType == 'mergePackage'" :headerCellStyle="unpackingAndPackagingData.headerCellStyle" :style="$popups.harvestRecordStyle(0.65)" @pageChange="getMergePackageData" :data="unpackingAndPackagingData.data" pagination :nowPage.sync="unpackingAndPackagingData.nowPage" :pageSize.sync="unpackingAndPackagingData.pageSize" :total.sync="unpackingAndPackagingData.total" @selectionChange="selectAllDel">
                    <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <el-table-column label="原数量" prop="boxQuan" align="center">
                    </el-table-column>
                    <el-table-column label="新数量" prop="newBoxQuan" align="center">
                    </el-table-column>
                    <el-table-column label="原批次号" prop="batchNo" align="center">
                    </el-table-column>
                    <el-table-column label="新批次号" prop="newBatchNo" align="center">
                    </el-table-column>
                    <el-table-column label="原库位" prop="laCode" align="center">
                    </el-table-column>
                    <el-table-column label="新库位" prop="newLaCode" align="center">
                    </el-table-column>
                    <el-table-column label="原箱号" prop="boxBarcode" align="center" width="210px">
                    </el-table-column>
                    <el-table-column label="新箱号" prop="newBoxBarcode" align="center" width="210px">
                    </el-table-column>
                    <el-table-column label="合包时间" prop="createTime" align="center" width="170px">
                    </el-table-column>
                    <el-table-column label="规值" prop="matSpecs" align="center">
                    </el-table-column>
                    <el-table-column label="操作人" prop="person" align="center">
                    </el-table-column>
                    <el-table-column label="操作人工号" prop="personNumber" align="center">
                    </el-table-column>
                </h-table>
            </div>
            <span slot="footer" class="dialog-footer footer-bottom">
                <!-- <el-button @click="closeProductPullDialog()" class="btn-t-info">关 闭</el-button> -->
                <!-- <el-button class="btn-t-edit" @click="openAddressDialog()">确 定</el-button> -->
            </span>
        </el-dialog>

        <!--合包弹窗-->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.9)" title="合包" :visible.sync="mergePackageDialog">
            <div style="font-size: 16px">
                <el-form label-position="right" label-width="100px" class="EL-Form">
                    <el-row>
                        <el-col :lg="6" :xl="6">
                            <el-form-item label="需合包箱号" class="EL-Form-Item">
                                <el-input el-input v-model="boxBarcode" placeholder="请输入" @keyup.enter.native="submitMerge(true)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="4" :xl="4">
                            <el-form-item class="btn-edit-delete EL-Form-Item">
                                <el-button class="btn-t-edit" @click="submitMerge(true)">
                                    查询
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :lg="6" :xl="6">
                            <el-form-item label="合包新批次" class="EL-Form-Item">
                                <el-select v-model="batchNo" placeholder="请选择">
                                    <el-option v-for="(item, index) in batchNoList" :key="index" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="6" :xl="6">
                            <el-form-item label="合包新库位" class="EL-Form-Item">
                                <el-select v-model="lcCodeByLcType" placeholder="请选择" @change="getLcCodeIsCorrect" filterable remote :remote-method="remoteMethodLcCode">
                                    <el-option v-for="(item, index) in lcCodeByLcTypeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="6" :xl="6">
                            <el-form-item label="原因" prop="sorTypeSub" class="EL-Form-Item">
                                <el-select v-model="reasonCode" clearable="clearable" filterable placeholder="请选择" >
                                    <el-option :value="item.reasonCode" :label="item.reasonCode +'-'+ item.reasonDescription" :key="index" v-for="(item, index) in transationReasonData"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <h-table :headerCellStyle="mergePackageData.headerCellStyle" :style="$popups.harvestRecordStyle(0.61)" :data="mergePackageData.data">
                    <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                    <el-table-column label="库位编号" prop="lcCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="物料描述" prop="matName" align="center">
                    </el-table-column>
                    <el-table-column label="数量" prop="matQuan" align="center">
                    </el-table-column>
                    <el-table-column label="批次号" prop="batchNo" align="center">
                    </el-table-column>
                    <el-table-column label="箱号" prop="boxBarcode" align="center">
                    </el-table-column>
                    <el-table-column label="规值" prop="matSpecs" align="center">
                    </el-table-column>
                    <el-table-column label="状态" prop="wiStatus" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                            <span v-if="scope.row.wiStatus == 'FREEZE'">冻结</span>
                            <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                            <span v-if="scope.row.wiStatus == 'DELETE'">作废</span>
                            <span v-if="scope.row.wiStatus == 'AGFREEZE'">人工冻结</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="入库时间" prop="matCreateTime" align="center" width="140px">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="
                  deleteRow(scope.$index, mergePackageData.data)
                " class="btn-t-delete">移除</el-button>
                        </template>
                    </el-table-column>
                </h-table>
            </div>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeMergePackageDialog()" class="btn-t-info">取 消</el-button>
                <el-button :loading="insertMergePackages" class="btn-t-edit" @click="insertMergePackage()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import moment from "moment";
    import confluenceVue from '../reportData/confluence.vue';
    export default {
        name: "Unpacking",
        data() {
            return {
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                /* 首页显示的数据 */
                mainSearch: {
                    query: {
                        fcCode: localStorage.getItem("fcCode") || "",
                        lcCode: "",
                        whCode: "",
                        matCode: "",
                        matName: "",
                        batchNo: "",
                        boxBarcode: "",
                        orderCode: "",
                        date: [],
                    },
                },
                //全选
                checkList: [],
                //拆包弹窗
                unpackDialog: false,
                // 拆包对象
                unpack: {
                    // 拆分的数量
                    // 原包装编码 BX2021100800004 XZP000150IM-3024430007
                    boxBarcode: "",
                    // 工厂编号
                    fcCode: "",
                    // 批次号
                    batchNo: "",
                    // 物料数量
                    matQuan: "",
                    // 物料描述
                    matName: "",
                    // 物料编号
                    matCode: "",
                    // 更新的时间
                    updateTime: "",
                    // 创建的时间
                    createTime: "",
                    // 库位编号
                    lcCode: "",
                    mtUnit: "",
                },
                // 拆包的数据
                unpackDate: "",
                //拆包数量
                boxNumber: "0",
                //拆包箱数
                boxCount: "1",
                //操作人
                person: localStorage.getItem("user"),
                //操作人工号
                personNumber: localStorage.getItem("empNumber"),

                downloadLoading: false, //下载中
                unpackings: false,

                checkListPrint: [],

                //位置集合
                inventoryLocationList: [],
                //新包装位置
                lcCodeType: [],
                //新包装的货位号
                newLcCode: "",
                //动态加载绑定
                optionProps: {
                    expandTrigger: 'click',
                    //multiple: true,
                    lazy: false,
                    lazyLoad: this.loadTechnologyId,
                    value: 'lmId',
                    label: 'lmName',
                    children: 'sysLocationMenuPOList'
                },
                //工厂对象
                fcCodeList: [],
                //工厂id条件
                fcCodeLmId: "",
                keyValue: 1,
                //货位号loading
                lcCodeLoading: false,
                //货位号
                lcCode: "",
                //移入货位集合
                lcCodeByLcTypeList: [],
                //移入货位
                lcCodeByLcType: "",
                //货位号判断
                lcCodeFlag: false,

                //打印
                printKuCunList: [],
                printList: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

                //交易原因
                transationReasonData: [],
                //交易原因
                reasonCode:"",

                //拆合包窗口
                unpackingAndPackagingDialog: false,
                unpackingAndPackagingData:{
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },   
                },
                unpackingAndPackagingSearch:{
                    fcCode: localStorage.getItem("fcCode"),
                    //recordType:"",
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    laCode: "",
                    boxBarcode: "",
                    date:[],
                },
                //记录类型
                recordType: "",
                //合包窗口
                mergePackageDialog: false,
                //需合包的箱号
                boxBarcode:"",
                //合包的批次号
                batchNo: "",
                //合包的批次号集合
                batchNoList:[],
                //合包集合对象
                mergePackageData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //合包操作动态加载
                insertMergePackages: false,
                //查询通道集合
                WhCodeList:[],
                // 库位调整查询条件
                storageObj: {
                    // 仓库
                    warehouse: [],
                    // 库区
                    lcCodeList: [],
                    // 物料编号
                    materialList: [],
                },
                //库存选择集合
                putInMotionData: [],
                //箱号判断
                boxBarcodeFlag: true,
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectTableData(newVal);
                    }, 1000)
                },
                deep: true,
            },
            unpackingAndPackagingSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.changeRecordType(newVal);
                    }, 1000)
                },
                deep: true,
            },
            inventoryLocationList(newVal) {
                this.keyValue++ //只要监听到数据源发生变化 ，改变keyValue的值，达到重新渲染的效果
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },
            pickerOptions1() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.unpackingAndPackagingSearch.date[0]) {
                            return time.getTime() < new Date(_this.unpackingAndPackagingSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions2() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.unpackingAndPackagingSearch.date[1]) {
                            return time.getTime() > new Date(_this.unpackingAndPackagingSearch.date[1]);
                        }
                    }
                }
            },
            startPickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                    if (_this.mainSearch.query.date[1]) {
                        return time.getTime() > new Date(_this.mainSearch.query.date[1]);
                    }
                    },
                };
                },
                finishPickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                    if (_this.mainSearch.query.date[0]) {
                        return time.getTime() < new Date(_this.mainSearch.query.date[0]);
                    }
                    },
                };
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.clickSelectList()
                }, 1000)
            },
            //获取数据
            getTransaction() {
                this.$http
                    .request({
                        url: "/api/transaction/getTransactionAll",
                        method: "GET",
                        params: {
                            transactionType: "IA",
                            pageNum: 1,
                            pageSize: 100,
                            reasonCode: ''
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.transationReasonData = resp.data.list || [];
                            this.reasonCode = "";
                        }
                    })
                    .catch((error) => {
                        
                    });
            },
            /* 所有重置的点击事件 */
            resetClick(type) {
                if (type == "mainSearch") {
                    this.mainSearch.query = {
                        fcCode: localStorage.getItem("fcCode") || "",
                        lcCode: "",
                        whCode: "",
                        matCode: "",
                        matName: "",
                        batchNo: "",
                        boxBarcode: "",
                        orderCode: "",
                        date: [],
                    };
                }
                this.mainData.nowPage = 1;
            },
            /**
             * swtch获取首页数据
             */
            clickSelectTableData(){
                this.mainData.nowPage = 1;
                this.getTableData();
            },
            /* 获取所有的通道(根据用户工厂) */
            getSysWarehouseAll() {
                this.$http
                    .request({
                    url: "/api/sysWarehouse/getSysWarehouseAll",
                    method: "GET",
                    params: {
                        fcCode: localStorage.getItem("fcCode") || "",
                    },
                    })
                    .then((resp) => {
                    if (resp.status == 100) {
                        this.WhCodeList = resp.data;
                    }
                    })
                    .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
            },
            /* 库存选择 */
            selectRepertory(selection) {
                this.putInMotionData = selection;
            },
            /**
             * 处理入库时间
             */
            dateFormat(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            /**
             * 主页计算合计
             */
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value)) && (column.property == "matQuan" || column.property == "matDistrQuan" ||column.property == "matAvaliableQuan")) {
                    sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    sums[index];
                } 
                });

                return sums;
            },
            /* 获取首页的数据 */
            getTableData() {
                this.$http
                    .request({
                    url: "/api/order/getStockList",
                    method: "GET",
                    params: {
                        fcCode: this.mainSearch.query.fcCode || null,
                        whCode: this.mainSearch.query.whCode || null,
                        matCode: this.mainSearch.query.matCode || null,
                        matName: this.mainSearch.query.matName || null,
                        batchNo: this.mainSearch.query.batchNo || null,
                        boxBarcode: this.mainSearch.query.boxBarcode || null,
                        lcCode: this.mainSearch.query.lcCode || null,
                        opCode: this.mainSearch.query.orderCode || null,
                        beginTime: this.mainSearch.query.date
                        ? this.mainSearch.query.date[0]
                        : null,
                        endTime: this.mainSearch.query.date
                        ? this.mainSearch.query.date[1]
                        : null,
                        pageNum: this.mainData.nowPage,
                        pageSize: this.mainData.pageSize,
                    },
                    })
                    .then((res) => {
                    if (res.status == 100) {
                        this.mainData.data = res.data.list || [];
                        this.mainData.total = res.data.total;
                    } else {
                        this.$message.error("错误");
                    }
                    })
                    .catch((error) => {
                    this.$message.error("错误");
                    });
            },
            /**
             * 打开合包窗口
             */
            showMergePackageDialog() {
                if (this.putInMotionData.length < 2) {
                    this.$message({
                        message: "请至少选择两条库存数据进行合包！",
                        type: "warning",
                    });
                    return;
                } else if (this.putInMotionData.length > 5) {
                    this.$message({
                        message: "最多对五条库存数据进行合包！",
                        type: "warning",
                    });
                    return;
                } 
                this.clearMerge();
                this.getTransaction();
                // this.getLmIdByFccode();
                var wiStatus = this.putInMotionData[0].wiStatus;
                var matCode = this.putInMotionData[0].matCode;
                var orderCode = this.putInMotionData[0].orderCode;
                var wiStatusFlag = false;
                var matCodeFlag = false;
                var wiStatusFreezeFlag = false;
                var orderCodeFlag = false;
                var flag = true;
                this.putInMotionData.forEach((item)=>{
                    if(item.wiStatus == "FREEZE"){
                        flag = false;
                        wiStatusFreezeFlag = true;
                    } else if(matCode != item.matCode){
                        flag = false;
                        matCodeFlag = true;
                    } else if(wiStatus != item.wiStatus){
                        flag = false;
                        wiStatusFlag = true;
                    } 
                    // else if(orderCode != item.orderCode || item.orderCode == ""){
                    //     flag = false;
                    //     orderCodeFlag = true;
                    // }
                    this.boxBarcode = item.boxBarcode;
                    this.submitMerge(false);                
                })
                if(wiStatusFreezeFlag){
                    this.$message({
                        message: "不能对拣货冻结的物料进行合包！",
                        type: "warning",
                    });
                    return;
                } else if(matCodeFlag){
                    this.$message({
                        message: "请输入物料相同的箱号！",
                        type: "warning",
                    });
                    return;
                } else if(wiStatusFlag){
                    this.$message({
                        message: "请输入物料状态相同的箱号！",
                        type: "warning",
                    });
                    return;
                } 
                // else if(orderCodeFlag){
                //     this.$message({
                //         message: "请选择批次相同的箱号！",
                //         type: "warning",
                //     });
                //     return;
                // }

                if(flag){
                    this.getSysLocationAll();
                    this.mergePackageDialog = true;
                } 
            },
            /**
             * 清除所选合包记录
             */
            clearMerge(){
                this.boxBarcode = "";
                this.mergePackageData.data = [];
                this.batchNoList = [];
                this.lcCodeList  = [];
            },
            //删除合包的箱
            deleteRow(index, rows) {
                var batchNo = rows[index].batchNo;
                var lcCode = rows[index].lcCode;
                var flag = true;
                var lcCodeFlag = true;
                rows.splice(index, 1);
                //如果删除元素后不存在该批次就删除（判断为防止重复批次删除）
                rows.forEach((item) => {
                    if (item.batchNo == batchNo) {
                        flag = false;
                    }
                    if (item.lcCode == lcCode) {
                        lcCodeFlag = false;
                    }
                })
                if (flag) {
                    this.batchNoList.splice(this.batchNoList.indexOf(batchNo), 1)
                }
                if (lcCodeFlag) {
                    this.lcCodeList.splice(this.lcCodeList.indexOf(lcCode), 1)
                }
                //清空文本框的值
                this.lcCode = "";
                this.batchNo = "";
            },
            //取消合包
            closeMergePackageDialog() {
                this.mergePackageDialog = false;
                this.boxBarcode = "";
                this.mergePackageData.data = [];
                this.batchNoList = [];
                this.batchNo = "";
                this.lcCodeList = [];
                this.lcCode = "";
                this.lcCodeByLcType = "";
            },
            //合包
            insertMergePackage() {
                this.getInventoryByLcCode();
                //判断是否存在两个以上的箱号
                if (this.mergePackageData.data.length < 2) {
                    this.$message({
                        message: "合包的箱数必须两个以上！",
                        type: "warning",
                    });
                    return;
                } else if (this.batchNo == "") {
                    this.$message({
                        message: "请选择合包后的新批次！",
                        type: "warning",
                    });
                    return;
                } else if (this.lcCodeByLcType == "") {
                    this.$message({
                        message: "请选择合包后的库位编号！",
                        type: "warning",
                    });
                    return;
                } else if (this.reasonCode == "") {
                    this.$message({
                        message: "请选择需合包的原因！",
                        type: "warning",
                    });
                    return;
                } else {
                    //进行合包
                    this.$confirm("提交并打印拆包标签", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.insertMergePackages = true;
                            this.$http
                                .request({
                                    url: "/api/SplitMergeMatChange/insertStockMerge",
                                    method: "POST",
                                    // showLoading: true,
                                    params: {
                                        lcCode: this.lcCodeByLcType, //选中的货位号
                                        batchNo: this.batchNo, //选中的批次号
                                        reasonCode: this.reasonCode, //选中的原因
                                        person: this.person, //合包操作人
                                        personNumber: this.personNumber, //合包操作人工号
                                    },
                                    data: this.mergePackageData.data,
                                })
                                .then((res) => {
                                    this.logContent = "batchNo：" + this.batchNo;
                                    if (res.status == 100) {
                                        // this.mainData.data = res.data.list;
                                        // this.mainData.total = res.data.total;
                                        this.insertMergePackages = false;
                                        this.mergePackageDialog = false;
                                        this.boxBarcode = "";
                                        this.mergePackageData.data = [];
                                        this.batchNoList = [];
                                        this.batchNo = "";
                                        this.lcCodeList = [];
                                        this.lcCode = "";
                                        this.lcCodeByLcType = "";
                                        this.$message({
                                            message: "合包和打印成功!",
                                            type: "success",
                                        });
                                        this.logRemarks = "splitMergeMatChange：提交并打印拆包标签成功";


                                        this.clickSelectTableData();

                                        //打印和包标签
                                        if (res.data.length > 0) {
                                            this.printMergeBarcode(res.data[0].newBoxBarcode);
                                        }

                                    } else {
                                        this.$message({
                                            message: res.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "splitMergeMatChange：提交并打印拆包标签失败";
                                    }
                                    this.systemLog();
                                    this.insertMergePackages = false;
                                });
                        })
                        .catch(() => {
                            this.insertMergePackages = false;
                            this.$message({
                                type: "info",
                                message: "已取消合包和打印",
                            });
                        });
                }
            },

            //合包后打印
            printMergeBarcode(boxBarcode) {
                this.$http
                    .request({
                        url: "/api/SplitMergeMatChange/mergeInventory",
                        method: "GET",
                        params: {
                            boxBarcodeList: boxBarcode
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.printList = res.data.list;

                            //打印
                            this.printList.forEach((item) => {

                                // let od = this.orderData.data.find(o => o.orderCode == item.orderCode);
                                var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                                if (item.matSpecs == undefined) {
                                    item.matSpecs = "";
                                }

                                if (item.boxHeight == undefined) {
                                    item.boxHeight = "";
                                }

                                //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                                //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                                //     "/" + produceTime + "/" + item.boxHeight + "/";

                                //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                    item.matCode + "," + item.matQuan + "," + item.matSpecs +
                                    "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";



                                var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                var barcodeData = {
                                    boxBarcode: item.boxBarcode,
                                    prodCode: item.matCode,
                                    prodName: item.matName,
                                    batchNo: item.batchNo,
                                    count: item.matQuan,
                                    checkPerson: localStorage.getItem("empNumber"),
                                    date: produceTime,
                                    poCode: item.orderCode,
                                    matSpecs: item.matSpecs,
                                    whCode: item.whCode,
                                    qrCode: qrCode,
                                    supply: "",
                                    printTime: printTime,
                                    location: item.lcCode
                                }

                                this.$printer.printWMSBarcode(barcodeData);
                            })

                        } else {
                            this.$message({
                                message: res.message,
                                type: "warning",
                            });
                        }


                    });
            },
            /**
             * 重置
             */
            resetUnpackingAndPackaging(){
                this.unpackingAndPackagingSearch = {
                    fcCode: localStorage.getItem("fcCode"),
                    matCode: "",
                    matName: "",
                    batchNo: "",
                    laCode: "",
                    boxBarcode: "",
                    date:[],
                }
            },
            /**
             * 切换查询记录类型
             */
            changeRecordType(){
                if(this.recordType == "unpacking"){
                    this.clickSelectList();
                }else if(this.recordType == "mergePackage"){
                    this.clickSelectListMerge();
                }
            },
            /**
             * 切换导出
             */
            downLoadFileExport(){
                if(this.recordType == "unpacking"){
                    this.downLoadFile();
                }else if(this.recordType == "mergePackage"){
                    this.downLoadFileMerge();
                }
            },
            /**
             * 打开拆合包记录
             */
            showUnpackingAndPackagingDialog(){
                this.recordType = "unpacking";
                this.clickSelectList();
                this.unpackingAndPackagingDialog = true;
            },
            showUnpackingDialog() {
                if (this.putInMotionData.length != 1) {
                    this.$message({
                        message: "请选择一条库存数据进行拆包！",
                        type: "warning",
                    });
                    return;
                }
                this.getLmIdByFccode();
                this.getSysLocationAll();
                //this.unpack = {};
                //this.unpackDate = "";
                this.unpack.boxBarcode = this.putInMotionData[0].boxBarcode;
                this.submit();
                this.unpackDialog = true;
            },
            /**
             * 根据工厂编号和货位号判断是否正确
             */
            getLcCodeIsCorrect() {
                this.$http
                    .request({
                        url: "/api/location/getLcCodeIsCorrect",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "", //工厂编号
                            lcCode: this.lcCodeByLcType, //库区号
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.lcCodeFlag = false;
                        } else {
                            this.lcCodeFlag = true;
                        }
                    });
            },
            /* 获取所有的库位 */
            getSysLocationAllList(lcCode) {
                this.$http
                    .request({
                    url: "/api/location/getLaCodeAllByType",
                    method: "GET",
                    params: {
                        //lcType: "AD",
                        fcCode: localStorage.getItem("fcCode") || "",
                        lcCode: lcCode || "",
                    },
                    })
                    .then((resp) => {
                    if (resp.status == 100) {
                        if (resp.data && resp.data.list) {
                            this.storageObj.lcCodeList = resp.data.list;
                            //this.rowLcCodeList = resp.data.list;
                        }else{
                            this.storageObj.lcCodeList = [];
                            //this.rowLcCodeList =[];
                        }
                    }
                    })
                    .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
            },
            /**
             * 远程搜索库位号
             */
            remoteMethodLcCodeList(query) {
                if (query || query == 0) {
                    this.lcCodeLoading = true;
                    this.getSysLocationAllList(query);
                    setTimeout(() => {
                    this.lcCodeLoading = false;
                    if (this.storageObj.lcCodeList != undefined) {
                        this.storageObj.lcCodeList = this.storageObj.lcCodeList.filter(
                        (item) => {
                            return (
                            item.lcCode.toLowerCase().indexOf(query.toLowerCase()) > -1
                            );
                        }
                        );
                        //this.rowLcCodeList=this.storageObj.lcCodeList;
                    }
                    }, 200);
                } else {
                    this.storageObj.lcCodeList = [];
                    //this.rowLcCodeList = [];
                }
            },
            /**
             * 远程搜索库位号
             */
            remoteMethodLcCode(query) {
                if (query !== '') {
                    this.lcCodeLoading = true;

                    this.lcCodeByLcType = query;
                    this.getLcCodeIsCorrect();
                    this.getSysLocationAll();

                    setTimeout(() => {
                        this.lcCodeLoading = false;
                        if (this.lcCodeByLcTypeList != undefined) {
                            this.lcCodeByLcTypeList = this.lcCodeByLcTypeList.filter(item => {
                                return item.lcCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeByLcTypeList = [];
                }
            },
            /**
             * 根据用户工厂编号获取所有的库位
             */
            getSysLocationAll() {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcCode: this.lcCodeByLcType,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.lcCodeByLcTypeList = resp.data.list;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 根据工厂查询id
             */
            getLmIdByFccode() {
                this.$http
                    .request({
                        url: "/api/location/getLocationMenuId",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.fcCodeLmId = res.data.list[0].lmId;
                            this.getLocationMenu();
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 动态加载拆包新包装位置
             */
            getUnpackLcCode() {

            },
            /**
             * 获取所有的仓库类型
             */
            getLocationMenu() {
                this.$http
                    .request({
                        url: "/api/location/getLocationMenu",
                        method: "GET",
                        params: {
                            lmId: this.fcCodeLmId,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.total != 0) {
                                if (this.fcCodeLmId) {
                                    this.optionProps.lazy = true;
                                    this.inventoryLocationList = resp.data.list;
                                } else {
                                    this.optionProps.lazy = false;
                                    this.lcCodeType = [];
                                }
                            }
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            /**
             * 根据仓库类型查询所有的货位号
             */
            // getLcCodeAllByType(){
            //     this.$http
            //         .request({
            //             url: "/api/location/getLcCodeByLocationMenuType",
            //             method: "GET",
            // showLoading: true,
            //             params: {
            //                 lmId: this.warehouseType,   
            //                 fcCode: localStorage.getItem("fcCode") || "",
            //             },
            //         })
            //         .then((resp) => {
            //             if (resp.status == 100) {
            //                 if(resp.data.total != 0){
            //                     var lcCodeList = "";
            //                     resp.data.list.forEach((item)=>{
            //                         lcCodeList += item.lcCode + ","
            //                     })
            //                     this.whInventorySearch.lcCodeList = lcCodeList;
            //                 }else{
            //                     this.whInventorySearch.lcCodeList = "";
            //                 }
            //             } else {
            //                 this.$message({
            //                     message: resp.message,
            //                     type: "error",
            //                 });
            //             }
            //         })
            //         .catch((error) => {
            //             this.$message({
            //                 message: "操作失败",
            //                 type: "error",
            //             });
            //         });    
            // },
            /**
             * 动态加载
             */
            loadTechnologyId(node, resolve) {
                const level = node.level
                const nodes = [];

                var lmId = "";
                if (level == 0) {
                    lmId = this.fcCodeLmId;
                } else if (level == 1) {
                    lmId = node.value
                } else if (level == 2) {
                    lmId = node.value
                } else if (level == 3) {
                    lmId = node.data.lmRealCode
                }

                if (level == 0 || level == 1 || level == 2) {
                    this.$http
                        .request({
                            url: "/api/location/getLocationMenu",
                            method: "GET",
                            params: {
                                lmId: lmId,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                if (resp.data.total != 0) {
                                    resp.data.list.forEach((item) => {
                                        var obj = {
                                            lmId: item.lmId,
                                            lmName: item.lmName,
                                            lmRealCode: item.lmRealCode,
                                            solidFlag: item.solidFlag,
                                            leaf: node.level >= 3
                                        }
                                        // if(item.parentId == 8){
                                        //     obj.leaf = node.level >= 2
                                        // }
                                        nodes.push(obj);
                                    })
                                }

                                resolve(nodes);
                            }
                        })
                } else if (level == 3) {
                    this.$http
                        .request({
                            url: "/api/location/getLcCodeByShelves",
                            method: "GET",
                            params: {
                                lcTypeSub: lmId,
                                fcCode: localStorage.getItem("fcCode") || "",
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                if (resp.data.total != 0) {
                                    resp.data.list.forEach((item) => {
                                        var obj = {
                                            lmId: item.lcCode,
                                            lmName: item.lcCode,
                                            lmRealCode: item.lcCode,
                                            solidFlag: item.solidFlag,
                                            leaf: node.level >= 3
                                        }
                                        nodes.push(obj);
                                    })
                                }

                                resolve(nodes);
                            }
                        })
                }

            },
            /**
             * 处理获取所有的货位号
             */
            getInventoryByLcCode() {
                this.newLcCode = this.lcCodeType[this.lcCodeType.length - 1]
            },
            // 点击查询按钮 重置页号
            clickSelectList(newVal) {
                this.unpackingAndPackagingData.nowPage = 1;
                this.getUnpackingData(newVal);
            },
            //点击查询按钮 重置页码
            clickSelectListMerge(){
                this.unpackingAndPackagingData.nowPage = 1;
                this.getMergePackageData();
            },
            /**
             * 获取所有的拆包记录
             */
            getUnpackingData() {
                this.$http
                    .request({
                        url: "/api/SplitMergeMatChange/getStockSplit",
                        method: "GET",
                        params: {
                            // person: localStorage.getItem("user") || "",
                            pageNum: this.unpackingAndPackagingData.nowPage, //	页号
                            pageSize: this.unpackingAndPackagingData.pageSize, //	页大小
                            fcCode: this.unpackingAndPackagingSearch.fcCode || null, //	工厂编号
                            laCode: this.unpackingAndPackagingSearch.laCode || null, //	库位编号
                            matCode: this.unpackingAndPackagingSearch.matCode || null, //	物料编号
                            matName: this.unpackingAndPackagingSearch.matName || null, //	物料描述
                            batchNo: this.unpackingAndPackagingSearch.batchNo || null, //	批次
                            boxBarcode: this.unpackingAndPackagingSearch.boxBarcode || null, //	箱号
                            beginTime: this.unpackingAndPackagingSearch.date ? this.unpackingAndPackagingSearch.date[0] : null,
                            endTime: this.unpackingAndPackagingSearch.date ? this.unpackingAndPackagingSearch.date[1] : null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.unpackingAndPackagingData.data = res.data.list;
                            this.unpackingAndPackagingData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 获取合包记录
             */
            getMergePackageData() {
                this.$http
                    .request({
                        url: "/api/SplitMergeMatChange/getStockMerge",
                        method: "GET",
                        params: {
                            pageNum: this.unpackingAndPackagingData.nowPage, //	页号
                            pageSize: this.unpackingAndPackagingData.pageSize, //	页大小
                            fcCode: this.unpackingAndPackagingSearch.fcCode || null, //	工厂编号
                            laCode: this.unpackingAndPackagingSearch.laCode || null, //	库位编号
                            matCode: this.unpackingAndPackagingSearch.matCode || null, //	物料编号
                            matName: this.unpackingAndPackagingSearch.matName || null, //	物料描述
                            batchNo: this.unpackingAndPackagingSearch.batchNo || null, //	批次
                            boxBarcode: this.unpackingAndPackagingSearch.boxBarcode || null, //	箱号
                            beginTime: this.unpackingAndPackagingSearch.date ? this.unpackingAndPackagingSearch.date[0] : null,
                            endTime: this.unpackingAndPackagingSearch.date ? this.unpackingAndPackagingSearch.date[1] : null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.unpackingAndPackagingData.data = res.data.list;
                            this.unpackingAndPackagingData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            //取消拆包
            NoUnpacking() {
                this.unpackDialog = false;
                this.unpack = {
                    boxBarcode: "",
                    fcCode: "",
                    batchNo: "",
                    matQuan: "",
                    matName: "",
                    matCode: "",
                    updateTime: "",
                    createTime: "",
                    lcCode: "",
                    mtUnit: "",
                },
                this.unpackDate = "";
                this.boxNumber = "0";
                this.boxCount = "1"
                this.inventoryLocationList = [];
                this.lcCodeType = [];
                this.lcCodeByLcType = "";
            },
            //拆包
            unpacking() {
                this.getInventoryByLcCode();
                //判断是否输入了正确的箱号
                if (this.unpackDate == "") {
                    this.$message({
                        message: "请输入正确的箱号进行拆包！",
                        type: "warning",
                    });
                    return;
                } else if (this.boxNumber == 0) {
                    this.$message({
                        message: "拆包数量不能为0！",
                        type: "warning",
                    });
                    return;
                } else if (this.boxNumber >= this.unpackDate.matQuan) {
                    this.$message({
                        message: "拆包数量超过了原包箱数量！",
                        type: "warning",
                    });
                    return;
                } else if (this.lcCodeByLcType == "" || this.lcCodeByLcType == undefined) {
                    this.$message({
                        message: "请选择新包装的库位编号！",
                        type: "warning",
                    });
                    return;
                } else if (this.unpackDate.wiStatus == "FREEZE") {
                    this.$message({
                        message: "不能对拣货冻结的物料进行拆包！",
                        type: "warning",
                    });
                    return;
                } else {
                    //进行拆包
                    this.$confirm("提交并打印拆包标签", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.unpackings = true;
                            this.$http
                                .request({
                                    url: "/api/SplitMergeMatChange/insertStockSplit",
                                    method: "POST",
                                    showLoading: true,
                                    params: {
                                        newLcCode: this.lcCodeByLcType, //包装新货位号
                                        boxNumber: this.boxNumber, // 拆包数量
                                        boxCount: this.boxCount,    //拆包箱数
                                        person: this.person, //拆包操作人
                                        personNumber: this.personNumber, //拆包操作人工号
                                    },
                                    data: this.unpack,
                                })
                                .then((res) => {
                                    this.logContent =
                                        "boxBarcode：" +
                                        this.unpack.boxBarcode +
                                        "\t" +
                                        "boxNumber：" +
                                        this.boxNumber;
                                    if (res.status == 100) {
                                        //this.mainData.data = res.data.list;
                                        //this.mainData.total = res.data.total;
                                        this.unpackDialog = false;
                                        this.boxNumber = "0";
                                        this.boxCount = "1";
                                        this.lcCodeByLcType = "";
                                        this.$message({
                                            message: "拆包成功!",
                                            type: "success",
                                        });

                                        this.clickSelectTableData();

                                        // 打印（新增拆包后获取最新一条拆包的库存记录）
                                        this.topOneSplitMergeMatChange(res.data);
                                        this.logRemarks = "splitMergeMatChange：拆包操作成功";

                                    } else {
                                        this.$message({
                                            message: res.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "splitMergeMatChange：拆包操作失败";
                                    }
                                    this.unpackings = false;
                                    this.logContent = JSON.stringify(this.unpack) + '\t' + 'boxNumber：' + this.boxNumber
                                    this.systemLog();
                                });
                        })
                        .catch(() => {
                            this.unpackings = false;
                            this.$message({
                                type: "info",
                                message: "已取消拆包和打印",
                            });
                        });
                }
            },
            // 打印 当前拆包后的数据
            topOneSplitMergeMatChange(printKuCunList) {
                //打印
                printKuCunList.forEach((item) => {

                    var produceTime = moment(item.matCreateTime).format("YYYYMMDD");
                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                        //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                        //     "/" + produceTime + "/" + item.boxHeight + "/";

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                        if (item.matSpecs == undefined) {
                            item.matSpecs = "";
                        }

                        var person = localStorage.getItem("user");
                        if (person != undefined && person != '') {
                            person = item.consignee;
                        }

                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxBarcode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.batchNo,
                            count: item.matQuan,
                            checkPerson: person,
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: item.whCode,
                            qrCode: qrCode,
                            supply: item.verdorCode,
                            printTime: printTime,
                            isSta: false,
                            printTwo: false,
                            location: item.lcCode,
                            boxHeight: item.boxHeight,
                            heatBatchNo: item.heatNumber,
                            luhao: item.heatNo,
                            oldBoxbarcode: item.oldBoxBarcode,
                            checkResult: item.checkResult
                        }
                        this.$printer.printWMSBarcode(barcodeData);
                })
            },

            //拆包回车查询库存
            submit() {
                this.$http
                    .request({
                        url: "/api/SplitMergeMatChange/getStockByBoxBarcode",
                        method: "GET",
                        params: {
                            boxBarcode: this.unpack.boxBarcode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            if (resp.data.list[0].matQuan == 1) {
                                this.$message({
                                    message: "该箱号数量为1不可以进行拆包操作！",
                                    type: "warning",
                                });
                                return;
                            } else if (resp.data.list[0].fcCode != localStorage.getItem("fcCode") || "") {
                                this.$message({
                                    message: "该工厂没有此箱号！",
                                    type: "warning",
                                });
                                return;
                            } else {
                                this.unpackDate = resp.data.list[0];
                                this.unpack.fcCode = this.unpackDate.fcCode;
                                this.unpack.batchNo = this.unpackDate.batchNo;
                                this.unpack.matQuan = this.unpackDate.matQuan;
                                this.unpack.matName = this.unpackDate.matName;
                                this.unpack.matCode = this.unpackDate.matCode;
                                this.unpack.createTime = this.unpackDate.createTime;
                                this.unpack.lcCode = this.unpackDate.lcCode;
                                this.unpack.wiStatus = this.unpackDate.wiStatus;
                                this.unpack.mtUnit = this.unpackDate.mtUnit;
                                this.unpack.matSpecs = this.unpackDate.matSpecs;
                                this.unpack.matCreateTime = this.unpackDate.matCreateTime;
                                this.unpack.whCode = this.unpackDate.whCode;
                                this.unpack.orderCode = this.unpackDate.orderCode;
                                this.unpack.boxBarcode = this.unpackDate.boxBarcode;
                                this.lcCodeByLcType = this.unpackDate.lcCode;
                            }
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "warning",
                            })
                            this.unpackDate = "";
                        }
                    });

            },
             /**
             * 回车提交
             */
            submitMerge(flag) {
                //根据箱号查询库存
                //判断是否输入了正确的箱号
                if (this.boxBarcode == "") {
                    this.$message({
                        message: "请输入箱号！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$http
                        .request({
                            url: "/api/SplitMergeMatChange/getStockByBoxBarcode",
                            method: "GET",
                            params: {
                                boxBarcode: this.boxBarcode, //箱号
                            },
                            data: this.unpack,
                        })
                        .then((res) => {
                            if (res.status == 100) {
                                var fcCode = res.data.list[0].fcCode; //工厂
                                if (fcCode != localStorage.getItem("fcCode") || "") {
                                    this.$message({
                                        message: "该工厂没有此箱号！",
                                        type: "warning",
                                    });
                                    return;
                                } else if (res.data.list[0].wiStatus == "FREEZE" && flag) {
                                    this.$message({
                                        message: "不能对拣货冻结的物料进行合包！",
                                        type: "warning",
                                    });
                                    return;
                                } else if (this.mergePackageData.data.length == 0) {
                                    //判断是否是第一次查询箱子
                                    this.mergePackageData.data.push(res.data.list[0]);
                                    //判断批次号是否重复  去重
                                    if (!this.batchNoList.includes(res.data.list[0].batchNo)) {
                                        this.batchNoList.push(res.data.list[0].batchNo);
                                    }
                                    if (!this.lcCodeList.includes(res.data.list[0].lcCode)) {
                                        this.lcCodeList.push(res.data.list[0].lcCode);
                                    }
                                    this.boxBarcode = "";
                                    this.mergePackageData.total += 1;
                                    // this.$message({
                                    //     message: "扫描箱号成功!",
                                    //     type: "success",
                                    // });
                                } else {
                                    var matCodeOne = res.data.list[0].matCode; //物料编号
                                    var wiStatus = res.data.list[0].wiStatus; //物料状态
                                    var matSpecs = res.data.list[0].matSpecs; //物料规值
                                    var barCode = res.data.list[0].boxBarcode; //箱号

                                    //判断箱号是否一样
                                    this.mergePackageData.data.forEach((item) => {
                                        if (barCode == item.boxBarcode && flag) {
                                            this.boxBarcodeFlag = false;
                                            this.$message({
                                                message: "请不要输入相同的箱号！",
                                                type: "warning",
                                            });
                                            return;
                                        }
                                    });

                                    if (this.boxBarcodeFlag) {
                                        //判断是否合包达到最大值五个
                                        if (this.mergePackageData.data.length == 5 && flag) {
                                            this.$message({
                                                message: "合包的箱数已到达最大值5个！",
                                                type: "warning",
                                            });
                                            return;
                                        } else if (
                                            matCodeOne != this.mergePackageData.data[0].matCode && flag
                                        ) {
                                            this.$message({
                                                message: "请输入物料相同的箱号！",
                                                type: "warning",
                                            });
                                            return;
                                        } else if (
                                            wiStatus != this.mergePackageData.data[0].wiStatus && flag
                                        ) {
                                            this.$message({
                                                message: "请输入物料状态相同的箱号！",
                                                type: "warning",
                                            });
                                            return;
                                        } else if (res.data.list[0].wiStatus == "FREEZE" && flag) {
                                            this.$message({
                                                message: "不能对拣货冻结的物料进行合包！",
                                                type: "warning",
                                            });
                                            return;
                                        } else {
                                            this.mergePackageData.data.push(res.data.list[0]);
                                            //判断批次号是否重复  去重
                                            if (!this.batchNoList.includes(res.data.list[0].batchNo)) {
                                                this.batchNoList.push(res.data.list[0].batchNo);
                                            }
                                            if (!this.lcCodeList.includes(res.data.list[0].lcCode)) {
                                                this.lcCodeList.push(res.data.list[0].lcCode);
                                            }
                                            this.boxBarcode = "";
                                            this.mergePackageData.total += 1;
                                            // this.$message({
                                            //     message: "扫描箱号成功!",
                                            //     type: "success",
                                            // });
                                        }
                                    }
                                    this.boxBarcodeFlag = true;
                                }
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: "error",
                                });
                            }
                        });
                }
            },
            //定时的去请求箱号，输入的箱号一改变就调用
            originalCaseInput() {
                if (this.unpack.boxBarcode) {
                    clearTimeout(this.antiShake);
                    this.antiShake = null;
                    this.antiShake = setTimeout(() => {
                        this.getStockByBoxBarcode(this.unpack.boxBarcode)
                            .then((resp) => {
                                if (resp.status == 100) {
                                    if (resp.data.list[0].matQuan == 1) {
                                        this.$message({
                                            message: "该箱号数量为1不可以进行拆包操作！",
                                            type: "warning",
                                        });
                                        return;
                                    } else {
                                        this.unpackDate = resp.data.list[0];
                                        this.unpack.fcCode = this.unpackDate.fcCode;
                                        this.unpack.batchNo = this.unpackDate.batchNo;
                                        this.unpack.matQuan = this.unpackDate.matQuan;
                                        this.unpack.matName = this.unpackDate.matName;
                                        this.unpack.matCode = this.unpackDate.matCode;
                                        this.unpack.createTime = this.unpackDate.createTime;
                                        this.unpack.lcCode = this.unpackDate.lcCode;
                                        this.unpack.wiStatus = this.unpackDate.wiStatus;
                                        this.unpack.mtUnit = this.unpackDate.mtUnit;
                                    }
                                } else {
                                    this.unpackDate = "";
                                }
                            })
                            .catch((err) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    }, 1000);
                } else {
                    clearTimeout(this.antiShake);
                    this.antiShake = null;
                    this.unpackDate = "";
                }
            },
            /**
             * 根据箱号进行查询
             */
            getStockByBoxBarcode(boxBarcode) {
                return new Promise((resolve, reject) => {
                    this.$http
                        .request({
                            url: "/api/SplitMergeMatChange/getStockByBoxBarcode",
                            method: "GET",
                            params: {
                                boxBarcode: boxBarcode,
                            },
                        })
                        .then((resp) => {
                            resolve(resp);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                });
            },
            /**
             * 重置
             */
            reset() {
                this.mainSearch = {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    laCode: "", //库位编号
                    matCode: "", // 物料编号
                    matName: "", // 物料描述
                    batchNo: "", // 批次
                    boxBarcode: "", // 箱号
                    date: [],
                };
                this.getUnpackingData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    // person: localStorage.getItem("user") || "",
                    fcCode: this.unpackingAndPackagingSearch.fcCode || null, // 工厂编号
                    laCode: this.unpackingAndPackagingSearch.laCode || null, // 库位编号
                    matCode: this.unpackingAndPackagingSearch.matCode || null, // 物料编号
                    matName: this.unpackingAndPackagingSearch.matName || null, // 物料描述
                    batchNo: this.unpackingAndPackagingSearch.batchNo || null, // 批次
                    boxBarcode: this.unpackingAndPackagingSearch.boxBarcode || null, // 箱号
                    beginTime: this.unpackingAndPackagingSearch.date ? this.unpackingAndPackagingSearch.date[0] : null,
                    endTime: this.unpackingAndPackagingSearch.date ? this.unpackingAndPackagingSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/SplitMergeMatChange/getStockSplit',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['物料编号', '物料描述', '原数量', '新数量', '批次号', '库位编号', '原箱号', '新箱号', '拆包时间', '规值', '操作人', '操作人工号']
                    const filterVal = ['matCode', 'matName', 'boxQuan', 'newBoxQuan', 'batchNo', 'laCode', 'boxBarcode', 'newBoxBarcode', 'createTime', 'matSpecs', 'person', 'personNumber']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '拆包单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_split：导出拆包记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            //表格导出
            downLoadFileMerge() {
                this.downloadLoading = true;
                var paramsObj = {
                    // person: this.mainSearch.person,
                    fcCode: this.unpackingAndPackagingSearch.fcCode || null, // 工厂编号
                    laCode: this.unpackingAndPackagingSearch.laCode || null, // 库位编号
                    matCode: this.unpackingAndPackagingSearch.matCode || null, // 物料编号
                    matName: this.unpackingAndPackagingSearch.matName || null, // 物料描述
                    batchNo: this.unpackingAndPackagingSearch.batchNo || null, // 批次
                    boxBarcode: this.unpackingAndPackagingSearch.boxBarcode || null, // 箱号
                    beginTime: this.unpackingAndPackagingSearch.date ? this.unpackingAndPackagingSearch.date[0] : null,
                    endTime: this.unpackingAndPackagingSearch.date ? this.unpackingAndPackagingSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/SplitMergeMatChange/getStockMerge',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoadMerge(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoadMerge(list) {

                list.forEach(function(c) {
                    if (c.wiStatus == 'NORMAL') {
                        c['wiStatus'] = '正常'
                    } else if (c.wiStatus == 'FREEZE') {
                        c['wiStatus'] = '拣配中'
                    } else if (c.wiStatus == 'AGFREEZE') {
                        c['wiStatus'] = '冻结'
                    }
                })

                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['物料编号', '物料描述', '原数量', '新数量', '原批次号', '新批次号', '原库位', '新库位', '原箱号', '新箱号', '合包时间', '规值', '状态',
                        '操作人', '操作人工号'
                    ]
                    const filterVal = ['matCode', 'matName', 'boxQuan', 'newBoxQuan', 'batchNo', 'newBatchNo', 'laCode', 'newLaCode', 'boxBarcode', 'newBoxBarcode', 'createTime', 'matSpecs' , 'wiStatus',
                        'person', 'personNumber'
                    ]
                    const data = this.formatJsonMerge(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '合包单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_merge：导出合包记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJsonMerge(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            selectAllDel(val) {
                this.checkListPrint = val
            },

            //标签打印
            rePrintBarcode() {
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.selectAllPrintList.forEach((item) => {

                        // let od = this.orderData.data.find(o => o.orderCode == item.orderCode);
                        var produceTime = moment(item.matCreateTime).format("YYYYMMDD");

                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                        //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                        //     "/" + produceTime + "/" + item.boxHeight + "/";

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                        if (item.matSpecs == undefined) {
                            item.matSpecs = "";
                        }

                        var person = localStorage.getItem("user");
                        if (person != undefined && person != '') {
                            person = item.consignee;
                        }



                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxBarcode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.batchNo,
                            count: item.matQuan,
                            checkPerson: person,
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: item.whCode,
                            qrCode: qrCode,
                            supply: "",
                            printTime: printTime,
                            isSta: false,
                            printTwo: false,
                            location: item.lcCode
                        }

                        this.$printer.printWMSBarcode(barcodeData);
                    })

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },

            /**
             * 打印
             */
            print() {
                if (this.putInMotionData.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                var boxBarcodeList = [];
                for (let i in this.putInMotionData) {
                    boxBarcodeList.push(this.putInMotionData[i].boxBarcode);
                }
                let boxBarcode = boxBarcodeList.join(',')
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.$http
                        .request({
                            url: "/api/SplitMergeMatChange/splitInventory",
                            method: "GET",
                            params: {
                                boxBarcodeList: boxBarcode
                            },
                        })
                        .then((res) => {
                            if (res.status == 100) {
                                this.printList = res.data.list;

                                //打印
                                this.printList.forEach((item) => {

                                    // let od = this.orderData.data.find(o => o.orderCode == item.orderCode);
                                    var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                                    //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                    // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                                    //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                                    //     "/" + produceTime + "/" + item.boxHeight + "/";

                                    //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                    var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                        item.matCode + "," + item.matQuan + "," + item.matSpecs +
                                        "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";


                                    if (item.matSpecs == undefined) {
                                        item.matSpecs = "";
                                    }

                                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                    var barcodeData = {
                                        boxBarcode: item.boxBarcode,
                                        prodCode: item.matCode,
                                        prodName: item.matName,
                                        batchNo: item.batchNo,
                                        count: item.matQuan,
                                        checkPerson: localStorage.getItem("empNumber"),
                                        date: produceTime,
                                        poCode: item.orderCode,
                                        matSpecs: item.matSpecs,
                                        whCode: item.whCode,
                                        qrCode: qrCode,
                                        supply: "",
                                        printTime: printTime,
                                        location: item.lcCode
                                    }

                                    this.$printer.printWMSBarcode(barcodeData);
                                })

                            } else {
                                this.$message({
                                    message: res.message,
                                    type: "warning",
                                });
                            }


                        });

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },

            /**
             * 打印
             */
            printDanju() {
                if (this.checkListPrint.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                var boxBarcodeList = [];
                for (let i in this.checkListPrint) {
                    boxBarcodeList.push(this.checkListPrint[i].newBoxBarcode);
                }
                let boxBarcode = boxBarcodeList.join(',')
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.$http
                        .request({
                            url: "/api/SplitMergeMatChange/splitInventory",
                            method: "GET",
                            params: {
                                boxBarcodeList: boxBarcode
                            },
                        })
                        .then((res) => {
                            if (res.status == 100) {
                                this.printList = res.data.list;

                                //打印
                                this.printList.forEach((item) => {

                                    // let od = this.orderData.data.find(o => o.orderCode == item.orderCode);
                                    var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

                                    if (item.matSpecs == undefined) {
                                        item.matSpecs = "";
                                    }

                                    if (item.boxHeight == undefined) {
                                        item.boxHeight = "";
                                    }

                                    //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                    // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                                    //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                                    //     "/" + produceTime + "/" + item.boxHeight + "/";

                                    //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                    var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                        item.matCode + "," + item.matQuan + "," + item.matSpecs +
                                        "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                    var barcodeData = {
                                        boxBarcode: item.boxBarcode,
                                        prodCode: item.matCode,
                                        prodName: item.matName,
                                        batchNo: item.batchNo,
                                        count: item.matQuan,
                                        checkPerson: localStorage.getItem("empNumber"),
                                        date: produceTime,
                                        poCode: item.orderCode,
                                        matSpecs: item.matSpecs,
                                        whCode: item.whCode,
                                        qrCode: qrCode,
                                        supply: "",
                                        printTime: printTime
                                    }

                                    this.$printer.printWMSBarcode(barcodeData);
                                })

                            } else {
                                this.$message({
                                    message: res.message,
                                    type: "warning",
                                });
                            }


                        });

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "拆包",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            //this.getUnpackingData();
             /* 获取所有的通道 */
            this.getSysWarehouseAll();
            /* 获取首页的数据 */
            this.getTableData();
            /* 获取所有的库位 */
            this.getSysLocationAllList();
        },
    };
</script>

<style scoped></style>